module.exports = __webpack_public_path__ + "static/media/logo.a42ed55f.png";